import React from 'react';
import { SegmentedControl } from '@mantine/core';
import { List, Grid3x3 } from 'lucide-react';
import { FilterBar } from './FilterBar';
import { TodoList } from '../types/todo';
import './SuperTaskToolbar.css';

interface SuperTaskToolbarProps {
  onFilterChange: (filters: { assignee: string; list: string | number; completed: 'today' | 'all' | 'hidden'; tags: string[]; search: string }) => void;
  currentFilters?: { assignee: string; list: string | number; completed: 'today' | 'all' | 'hidden'; tags: string[]; search: string };
  selectedList?: TodoList | null;
  onCreateList?: () => void;
  onEditList?: () => void;
  onNewTodoCreated?: (taskId: number, title: string) => void;
  viewMode?: 'list' | 'matrix';
  onViewModeChange?: (mode: 'list' | 'matrix') => void;
}

export const SuperTaskToolbar: React.FC<SuperTaskToolbarProps> = ({
  onFilterChange,
  currentFilters,
  selectedList,
  onCreateList,
  onEditList,
  viewMode = 'list',
  onViewModeChange
}) => {
  return (
    <div className="super-task-toolbar">
      <FilterBar
        onFilterChange={onFilterChange}
        currentFilters={currentFilters}
        selectedList={selectedList}
        onCreateList={onCreateList}
        onEditList={onEditList}
      />
      
      {onViewModeChange && (
        <div className="view-mode-toggle">
          <SegmentedControl
            value={viewMode}
            onChange={(value) => onViewModeChange(value as 'list' | 'matrix')}
            data={[
              { 
                value: 'list', 
                label: (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <List size={14} />
                    <span>List</span>
                  </div>
                )
              },
              { 
                value: 'matrix', 
                label: (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Grid3x3 size={14} />
                    <span>Matrix</span>
                  </div>
                )
              }
            ]}
            size="xs"
          />
        </div>
      )}
    </div>
  );
};